export default {
  app: {
    golf: {
      title: 'Course information',
      hasEVChargingPoint: 'EV Charging point',
      hasCaddieService: 'Caddie service',
      hasTrolley: 'Trolley',
      hasBuggy: 'Buggy',
      hasClubRental: 'Club rental',
      hasAcademy: 'Academy',
      hasMarshal: 'Marshal',
      hasPGACertification: 'PGA Certification',
      hasTrainingArea: 'Training area',
      hasRestaurant: 'Restaurant',
      hasHotel: 'Hotel',
      hasDogsOnCourse: 'Dogs on course',
      numberOfHoles: 'Number of holes',
    },
  },
};
